<template>
  <div class="mediaServer_wrap english_container">
    <myHeader />
    <!-- banner模块 -->

    <div class="banner">
      <canvas id="canvasId"></canvas>

      <div class="banner_content">
        <p
          class="wow fadeInUp"
          style="font-size: 80px; font-weight: 900; margin-bottom: 20px"
        >
          hecoos Media Server
        </p>
        <p style="font-weight: 400" class="wow fadeInUp enTwoProductDesc">
          A high-performance engine seamlessly integrated with the hecoos
          ecosystem
        </p>

        <router-link
          id="media_server_contact_us"
          class="callMe"
          :to="{ name: 'enCaseDemonstration', hash: '#specific-position' }"
          >Contact Us</router-link
        >
      </div>
    </div>

    <!-- 产品模块 -->
    <div class="product colorBlack" id="product_section">
      <div class="tab" id="tab">
        <p class="wow fadeInUp enProductTitle" style="margin-bottom: 0px">
          hecoos Server
        </p>
        <p class="wow fadeInUp enProductTitle">hecoos Server Product Suite</p>
        <div class="switch" ref="switch_list">
          <!-- 为每个 span 绑定点击事件和动态类名 -->
          <span
            :class="{ select: currentTabIndex === 0 }"
            @click="selectTab(0)"
          >
            Server-D
          </span>
          <span
            :class="{ select: currentTabIndex === 1 }"
            @click="selectTab(1)"
          >
            Server-C
          </span>
          <span
            :class="{ select: currentTabIndex === 2 }"
            @click="selectTab(2)"
          >
            Server-R
          </span>
          <div
            class="underline"
            :style="{
              width: underlineWidth + 'px',
              left: underlineLeft + 'px',
            }"
          ></div>
        </div>
      </div>
      <!-- 产品内容部分 -->
      <div>
        <div class="layout_media"></div>
        <div class="content">
          <!-- server-D部分 -->
          <div class="layout_media">
            <div class="serverContent" v-show="showContents[0]">
              <p
                style="font-size: 24px; margin-bottom: 40px"
                class="wow fadeInUp"
              >
                Server-D
              </p>
              <p
                style="font-size: 54px; margin-bottom: 60px; font-weight: 700"
                class="wow fadeInUp"
              >
                Powerful functionality&nbsp;&nbsp;<span style="color: #2a82e4"
                  >Stable and efficient</span
                >
              </p>
              <p
                style="
                  font-size: 22px;
                  color: #86868b;
                  line-height: 36px;
                  letter-spacing: 1.2px;
                  text-align: justify;
                "
                class="wow fadeInUp"
              >
                Engineered as the core hardware for the hecoos software
                ecosystem, hecoos Server – D delivers professional-grade
                reliability and blistering performance, built to withstand the
                rigors of live events and deploy in a flash. Move beyond
                conventional stage playback. Server – D drives complex 3D
                visuals and seamlessly unifies control of video, lighting,
                automation, and more. It’s your powerhouse for virtual
                production, effortlessly extending LED wall output capabilities.
                With the integrated hecoos software suite, witness your creative
                vision manifest. Leveraging the cohesive hecoos workflow, Server
                – D empowers you to orchestrate every detail – from initial
                concept to breathtaking final delivery. Experience true
                “Design-to-Reality” and captivate audiences with visually
                stunning, unforgettable spectacles.
              </p>
              <img
                style="width: 1201px; height: 634px; margin: 80px 0"
                src="https://download.hecoos.com/enlightv/2025-17/9bf5a3c707dd185121045f4da6e76657.png"
                alt=""
                class="wow fadeInUp"
              />
              <!-- 亮点模块 -->
              <clickSwitch :Info="Info" class="wow fadeInUp"></clickSwitch>

              <!-- 参数部分 -->
              <p
                style="font-size: 24px; margin: 150px 0 60px"
                class="wow fadeInUp"
              >
                <!-- Hardware specifications -->
              </p>
              <p
                style="font-size: 70px; font-weight: 700; margin-bottom: 16px"
                class="wow fadeInUp"
              >
                Take a close look at the parameters.
              </p>
              <img
                style="width: 1246px; height: 582px"
                src="https://download.hecoos.com/enlightv/2025-17/6af24860b3995a3bb2d8bad2e1bf0732.png"
                alt=""
                class="wow fadeInUp"
              />
            </div>
            <div class="parameters" v-show="showContents[0]">
              <div class="parameters_content">
                <p
                  style="font-size: 48px; display: inline-block"
                  class="wow fadeInUp w_400"
                >
                  Hardware Specifications
                </p>
                <div class="detailed">
                  <p class="wow fadeInUp">
                    Operating voltage: 100 - 240V, 50 - 60Hz, 13 amps. Redundant
                    power supply operating power: 800W. @110V (normal), 1000W @
                    110V (maximum)<br />
                    Case specification: 4U 19" rack-mounted system. Operating
                    system: Windows 10 Pro <br />
                    CPU Processor: Intel Xeon Gold 6226R Processor (16 cores, 32
                    threads)<br />
                    System memory: 64G RDIMM DDR4 memory (32G x 2)<br />
                    Memory requirement for a single system: 16G<br />
                    Single unit supports image pixel points: 1920*1080*16<br />
                    Artnet: Support<br />
                    System hard disk: 2TB SSD<br />
                    Maximum number of SSD hard drives: 4<br />
                    Supports physical superior-level cascading expansion mode.
                    The expansion mode is not limited by quantity. Support for
                    Optitrack infrared tracking system.<br />
                    Equipped with back panel lighting <br />
                    Equipped with PCI-E expansion connectors<br />
                    Network interface: 1xGB LAN, 10xGB LAN<br />
                    Support for OLED state text display (detailed
                    description)<br />
                    Width and depth of the chassis (mm): 430 (width) * 178
                    (height) * 634 (depth)
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <p
                  style="font-size: 48px; display: inline-block"
                  class="wow fadeInUp w_400"
                >
                  <!-- Work environment tolerance -->
                  Operational Environmental Tolerance
                </p>
                <div class="detailed">
                  <p class="wow fadeInUp">
                    Temperature: 5 - 35°C (40° - 95°)<br />
                    Humidity: 5% - 95% (non-condensing)<br />
                    Altitude: 0 - 8850 ft (0 - 2700 m)<br />
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <p
                  style="font-size: 48px; display: inline-block"
                  class="wow fadeInUp w_400"
                >
                  I/O Specification
                </p>
                <div class="detailed">
                  <div class="test">
                    <div class="detailed_content">
                      <p class="wow fadeInUp">
                        Video output<br />
                        <span style="color: #a6a6a6"
                          >6 x DisplayPort 1.2<br />
                          Maximum resolution of the independent output
                          channel(4096x2160)</span
                        ><br />
                      </p>
                    </div>
                    <div class="detailed_content">
                      <p class="wow fadeInUp">
                        Video input<br />
                        <span style="color: #a6a6a6"
                          >6 x DisplayPort 1.2 <br />
                          Maximum resolution of the independent output
                          channel(4096x2160)</span
                        ><br />
                      </p>
                    </div>
                  </div>
                  <div class="test">
                    <div class="detailed_content">
                      <p class="wow fadeInUp">
                        Data/Peripheral Devices<br />
                        <span style="color: #a6a6a6"
                          >6 x DisplayPort 1.2<br />
                          Maximum resolution of the independent output
                          channel(4096x2160)</span
                        ><br />
                      </p>
                    </div>
                    <div class="detailed_content">
                      <p class="wow fadeInUp">
                        Audio and video input/output<br />
                        <span style="color: #a6a6a6"
                          >6 x DisplayPort 1.2<br />
                          Maximum resolution of the independent output
                          channel(4096x2160)</span
                        ><br />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="parameters_content">
                <p
                  style="font-size: 48px; display: inline-block"
                  class="wow fadeInUp w_400"
                >
                  <!-- Original factory parts -->
                  Accessories
                </p>
                <div class="detailed">
                  <p class="wow fadeInUp">
                    Mechanical keyboard and mouse <br />
                    800W Platinum Power Supply <br />
                    circumferential line<br />
                    DP to DVI adapter cable x6SM <br />
                    DP cable x4
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <p
                  style="font-size: 48px; display: inline-block"
                  class="wow fadeInUp w_400"
                >
                  <!-- After-sales Guarantee -->
                  After-Sales Support
                </p>
                <div class="detailed">
                  <p class="wow fadeInUp">
                    Software is provided for free for life. <br />
                    Use and upgrade servers <br />
                    Hardware comes with two-year free warranty service. <br />
                    Remote technical support
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- server-C部分 -->
          <div class="layout_media">
            <div class="serverContent" v-show="showContents[1]">
              <p
                style="font-size: 24px; margin-bottom: 40px"
                class="wow fadeInUp"
              >
                Server-C
              </p>
              <p
                style="font-size: 54px; margin-bottom: 60px; font-weight: 700"
                class="wow fadeInUp"
              >
                <!-- xR-C Media Server&nbsp;&nbsp; -->
                <span style="color: #2a82e4"
                  >The Intelligent Hub for Virtual Production</span
                >
              </p>
              <p
                style="
                  font-size: 22px;
                  color: #86868b;
                  line-height: 36px;
                  letter-spacing: 1.2px;
                "
                class="wow fadeInUp"
              >
                Engineered as the core engine for virtual production, xR-C
                serves as the real-time command center on set. It dynamically
                synchronizes with tracking systems, processing actor positions
                and camera movements to instantly orchestrate render engines.
                This enables seamless perspective switching, ensuring
                frame-accurate alignment between virtual and physical elements.
                When integrated with lighting systems, xR-C recalibrates virtual
                light in real time, precisely matching scene ambience to deliver
                cinematic visual authenticity. Built with modular scalability,
                mission-critical stability, and a comprehensive I/O matrix, xR-C
                guarantees robust on-set performance. Its end-to-end
                customizable architecture empowers creators to master every
                dimension of virtual production – from concept to final capture.
              </p>
              <img
                style="width: 1201px; height: 634px; margin: 80px 0"
                src="https://download.hecoos.com/enlightv/2025-17/58ba9ed9b9f7b2f7e2a0b221d3438db8.png"
                alt=""
                class="wow fadeInUp"
              />
              <!-- 亮点模块 -->
              <clickSwitch :Info="Info" class="wow fadeInUp"></clickSwitch>
              <!-- 参数部分 -->

              <p
                style="font-size: 24px; margin: 150px 0 60px"
                class="wow fadeInUp"
              >
                <!-- Hardware Specifications -->
              </p>
              <p
                style="font-size: 70px; font-weight: 700; margin-bottom: 16px"
                class="wow fadeInUp"
              >
                Take a close look at the parameters.
              </p>
              <img
                style="width: 1246px; height: 582px"
                src="https://download.hecoos.com/enlightv/2025-17/6af24860b3995a3bb2d8bad2e1bf0732.png"
                alt=""
                class="wow fadeInUp"
              />
            </div>
            <div class="parameters" v-show="showContents[1]">
              <div class="parameters_content">
                <p
                  style="font-size: 32px; display: inline-block"
                  class="wow fadeInUp w_400"
                >
                  Hardware Specifications
                </p>
                <div class="detailed">
                  <p class="wow fadeInUp">
                    CPU Processor: Intel Xeon Gold 6226R Processor (16 cores, 32
                    threads)<br />
                    Motherboard: Customized motherboard<br />
                    System memory: 64G RDIMM DDR4 memory (32G x 2) <br />
                    Hard Disk 1: M.2 NVMe SSD 2TB System Disk <br />
                    Hard Disk 2: U.2 NVMe SSD Data Disk 4TB<br />
                    Fan model: Customized cooling fan <br />
                    Case model: Custom case <br />
                    Graphics card: A5000 24GB GDDR6<br />
                    Synchronous Card: NVIDIA 2nd Generation Synchronous Card
                    <br />
                    Card: BMD-8k pro<br />
                    BMC card: Remote Network Management <br />
                    Network card 1: 1Gb RJ45 <br />
                    NIC 2: Mellanox 100Gb<br />
                    Optical port multi-screen card backplate: Customized
                    multi-screen card backplate<br />
                    Multi-screen card motherboard: Customized multi-screen card
                    motherboard DP/DVI
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <p
                  style="font-size: 32px; display: inline-block"
                  class="wow fadeInUp w_400"
                >
                  <!-- Work environment tolerance -->
                  Operational Environmental Tolerance
                </p>
                <div class="detailed">
                  <p class="wow fadeInUp">
                    Temperature: 5 - 35°C (40° - 95°)<br />
                    Humidity: 5% - 95% (non-condensing)<br />
                    Altitude: 0 - 8850 ft (0 - 2700 m)<br />
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <p
                  style="font-size: 32px; display: inline-block"
                  class="wow fadeInUp w_400"
                >
                  I/O Specification
                </p>
                <div class="detailed">
                  <div class="test">
                    <div class="detailed_content">
                      <p class="wow fadeInUp">
                        Video output<br />
                        <span style="color: #a6a6a6"
                          >6 x DisplayPort 1.2<br />
                          Maximum resolution of the independent output
                          channel(4096x2160)</span
                        ><br />
                      </p>
                    </div>
                    <div class="detailed_content">
                      <p class="wow fadeInUp">
                        Video Input<br />
                        <span style="color: #a6a6a6"
                          >6 x DisplayPort 1.2 <br />
                          Maximum resolution of the independent output
                          channel(4096x2160)</span
                        ><br />
                      </p>
                    </div>
                  </div>
                  <div class="test">
                    <div class="detailed_content">
                      <p class="wow fadeInUp">
                        Data/Peripheral Devices<br />
                        <span style="color: #a6a6a6"
                          >6 x DisplayPort 1.2<br />
                          Maximum resolution of the independent output
                          channel(4096x2160)</span
                        ><br />
                      </p>
                    </div>
                    <div class="detailed_content">
                      <p class="wow fadeInUp">
                        Audio and video input/output<br />
                        <span style="color: #a6a6a6"
                          >6 x DisplayPort 1.2<br />
                          Maximum resolution of the independent output
                          channel(4096x2160)</span
                        ><br />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="parameters_content">
                <p class="w_400" style="font-size: 32px; display: inline-block">
                  <!-- Original factory parts -->
                  Accessories
                </p>
                <div class="detailed">
                  <p class="wow fadeInUp">
                    Mechanical keyboard and mouse <br />
                    800W Platinum Power Supply <br />
                    circumferential line<br />
                    DP to DVI adapter cable x6SM <br />
                    DP Line x4
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <p
                  style="font-size: 32px; display: inline-block"
                  class="wow fadeInUp w_400"
                >
                  <!-- After-sales Guarantee -->
                  After-Sales Support
                </p>
                <div class="detailed">
                  <p class="wow fadeInUp">
                    Software is provided for free for life. <br />
                    Use and upgrade servers <br />
                    Hardware comes with two-year warranty and free service.
                    <br />
                    Remote technical support
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- server-R部分 -->
          <div class="layout_media">
            <div class="serverContent" v-show="showContents[2]">
              <p
                style="font-size: 24px; margin-bottom: 40px"
                class="wow fadeInUp"
              >
                Server-R
              </p>
              <p
                style="
                  font-size: 54px;
                  font-weight: 700;
                  margin-bottom: 60px;
                  line-height: 54px;
                "
                class="wow fadeInUp"
              >
                Freedom to Configure
                <span style="color: #2a82e4">Agility in Allocation</span>
              </p>
              <p
                style="
                  font-size: 22px;
                  color: #86868b;
                  line-height: 36px;
                  letter-spacing: 1.2px;
                "
                class="wow fadeInUp"
              >
                hecoos Server xR-R: The Universal Engine Hub for Virtual
                Production Powered to harness leading render engines – Unreal
                Engine, Notch, Unity 3D – thecoos Server xR-R media server
                seamlessly integrates 3D virtual scenes into live-action
                workflows. Leveraging 100G SMPTE ST 2110 transport, it delivers
                frame-synced ultra-low latency with broadcast-grade uncompressed
                fidelity. Break free from engine constraints: Operate multiple
                renderers in a unified pipeline, dynamically allocating
                resources for complex scenes. When tackling extreme rendering
                loads, its scalable cluster architecture maintains stable
                feature-grade real-time output even at high bitrates. Integrated
                real-time ray tracing optimization and cross-engine control
                protocols deliver end-to-end industrial robustness for
                mission-critical virtual production.
              </p>
              <img
                style="width: 1201px; height: 634px; margin: 80px 0"
                src="https://download.hecoos.com/enlightv/2025-17/93682b68b9c7f106bf40939e1059af7a.png"
                alt=""
                class="wow fadeInUp"
              />
              <!-- 亮点模块 -->
              <clickSwitch :Info="Info" class="wow fadeInUp"></clickSwitch>

              <!-- 参数部分 -->

              <p
                style="font-size: 24px; margin: 150px 0 60px"
                class="wow fadeInUp"
              >
                <!-- Hardware Specifications -->
              </p>
              <p
                style="font-size: 70px; font-weight: 700; margin-bottom: 16px"
                class="wow fadeInUp"
              >
                Take a close look at the parameters.
              </p>
              <img
                style="width: 1246px; height: 582px"
                src="https://download.hecoos.com/enlightv/2025-17/6af24860b3995a3bb2d8bad2e1bf0732.png"
                alt=""
                class="wow fadeInUp"
              />
            </div>
            <div class="parameters" v-show="showContents[2]">
              <div class="parameters_content">
                <p
                  style="font-size: 32px; display: inline-block"
                  class="wow fadeInUp w_400"
                >
                  Hardware Specifications
                </p>
                <div class="detailed">
                  <p class="wow fadeInUp">
                    CPU Processor: Intel Core Ultra 9 Processor 285K<br />
                    Motherboard: ASUS Z890 Series motherboard <br />
                    System memory: 64G DDR5 memory <br />
                    Hard Disk 1: M.2 NVMe<br />
                    2T SSD system disk <br />

                    Case model: General version case<br />
                    System hard disk:2TB SSD <br />
                    Maximum number of SSD hard drives:4<br />
                    Supports physical superior-level cascading expansion mode.
                    The expansion mode is not limited by quantity. Support for
                    Optitrack infrared tracking system.<br />
                    Equipped with back panel lighting <br />
                    Equipped with PCI-E expansion connectors <br />
                    Network interface: 1xGB LAN, 10xGB LAN<br />
                    Support for OLED state text display (detailed
                    description)<br />
                    Width and depth of the chassis (mm): 430 (width) * 178
                    (height) * 634 (depth)
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <p
                  style="font-size: 32px; display: inline-block"
                  class="wow fadeInUp w_400"
                >
                  <!-- Work environment tolerance -->
                  Operational Environmental Tolerance
                </p>
                <div class="detailed">
                  <p class="wow fadeInUp">
                    temperature:5-35°C(40°-95°) <br />
                    Humidity:5%-95%(non-condensing) <br />
                    Altitude:0-8850ft(0-2700m)<br />
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <p
                  style="font-size: 32px; display: inline-block"
                  class="wow fadeInUp w_400"
                >
                  I/O Specification
                </p>
                <div class="detailed">
                  <div class="test">
                    <div class="detailed_content">
                      <p class="wow fadeInUp">
                        Video output<br />
                        <span style="color: #a6a6a6"
                          >6 x DisplayPort 1.2<br />
                          Maximum resolution of the independent output
                          channel(4096x2160)</span
                        ><br />
                      </p>
                    </div>
                    <div class="detailed_content">
                      <p class="wow fadeInUp">
                        Video Input<br />
                        <span style="color: #a6a6a6"
                          >6 x DisplayPort 1.2 <br />
                          Maximum resolution of the independent output
                          channel(4096x2160)</span
                        ><br />
                      </p>
                    </div>
                  </div>
                  <div class="test">
                    <div class="detailed_content">
                      <p class="wow fadeInUp">
                        Data/Peripheral Devices<br />
                        <span style="color: #a6a6a6"
                          >6 x DisplayPort 1.2<br />
                          Maximum resolution of the independent output
                          channel(4096x2160)</span
                        ><br />
                      </p>
                    </div>
                    <div class="detailed_content">
                      <p class="wow fadeInUp">
                        Audio and video input/output<br />
                        <span style="color: #a6a6a6"
                          >6 x DisplayPort 1.2<br />
                          Maximum resolution of the independent output
                          channel(4096x2160)</span
                        ><br />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="parameters_content">
                <p
                  style="font-size: 32px; display: inline-block"
                  class="wow fadeInUp w_400"
                >
                  <!-- Original factory parts -->
                  Accessories
                </p>
                <div class="detailed">
                  <p class="wow fadeInUp">
                    Mechanical keyboard and mouse <br />
                    800W Platinum Power Supply <br />
                    circumferential line<br />
                    DP to DVI adapter cable x6SM <br />
                    DP Line x4
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <p
                  style="font-size: 32px; display: inline-block"
                  class="wow fadeInUp w_400"
                >
                  <!-- After-sales Guarantee -->
                  After-Sales Support
                </p>
                <div class="detailed">
                  <p class="wow fadeInUp">
                    Software is provided for free for life. <br />
                    Use and upgrade servers <br />
                    Hardware comes with two-year warranty and free service.
                    <br />
                    Remote technical support
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <myText :reviews="reviews" v-if="showContents[0]"></myText>
    <myInquire></myInquire>
    <myFooter></myFooter>
    <BackToTop />
  </div>
</template>

<script>
import myHeader from "@/components/en_pc/myHeader.vue";
import myFooter from "@/components/en_pc/myFooter.vue";
import test from "@/components/en_pc/test.vue";
import myText from "@/components/en_pc/myText.vue";
import myInquire from "@/components/en_pc/myInquire.vue";
import clickSwitch from "@/components/en_pc/clickSwitch.vue";
import BackToTop from "@/components/en_pc/BackToTop";
import { initThreeNoiseEffect } from "@/utils/threeNoiseEffect.js";
import Test from "../../../components/en_pc/test.vue";
export default {
  data() {
    return {
      underlineWidth: 0,
      underlineLeft: 0,
      // 新增变量，用于记录当前选中的 tab 索引
      currentTabIndex: 0,
      // 新增数组，用于控制每个产品内容的显示状态
      showContents: [true, false, false, false],
      tabInfo: {
        server_D: {
          tabName: [
            "Content playback",
            "Screen mapping",
            "Multi-screen display",
            "3DMapping",
            "Flexible I/O expansion",
            "Tracking system integration",
          ],
          imgList: [
            "https://download.hecoos.com/enlightv/2025-17/fae918c5d4a93841bc4769f8c4568c8b.png",
            "https://download.hecoos.com/enlightv/2025-17/a6c324978b81ed0e5dc01b3db014ee17.png",
            "https://download.hecoos.com/enlightv/2025-37/58a8c128d1bacd451c09589dc9273168.png",
            "https://download.hecoos.com/enlightv/2025-17/896f2237bace53a89cbaa2bc7804040a.png",
            "https://download.hecoos.com/enlightv/2025-17/96115941405a2a888c8e3bde5c6ad839.png",
            "https://download.hecoos.com/enlightv/2025-17/d9fac1b1240180c181999e676c3d6d53.png",
          ],
          msgList: [
            "A high-performance non-linear editing (NLE) engine delivering real-time 2D/3D graphics rendering via OpenGL and DirectX pipelines. Supporting industry-standard codecs including HAP, HEVC, ProRes, and 30+ video formats, it ensures frame-accurate playback for all media types - from compressed streams to image sequences.",
            "hecoos delivers precision video projection onto diverse display surfaces by using industry-standard geometric mapping techniques—including planar, spherical, perspective-correct, and cylindrical projections—enabling seamless 3D projection mapping and extended reality (xR) background generation tailored to creative requirements.",
            "Optimized Version:The system's scalable-resolution decoding engine integrates with a distributed server architecture to deliver frame-accurate playback across virtually unlimited LED and projection displays at native resolutions up to 16K.",
            "hecoos supports 3D model import with UV-based texture mapping capabilities, enabling video projection directly onto model surfaces. This facilitates 3D spatial previsualization and perspective validation. Using UV coordinates or perspective projection algorithms derived from the 3D model, the system dynamically generates image content and calibrates real-time projection output to physical surfaces through geometric recalibration, delivering precise visual alignment.",
            "hecoos extends I/O capabilities through Arduino-compatible kit integration or direct interfacing with industrial devices (radars, encoders, controllers). This enables native control of motion systems—including servo motors, linear actuators, and stepper motors—via standardized protocols like Modbus, CAN bus, or PWM signals, significantly expanding implementation options for kinetic installations.",
            "hecoos connects leading tracking systems (VICON, Blacktrax, Optitrack, Stype, Mo-sys, Redspy, etc.) with sensors (Radar, Infrared, Kinect, etc.) and open-source hardware (ARDUINO, Raspberry Pi, etc.), bringing together data streams for precise, real-time control across a variety of extended reality applications",
          ],
        },
        server_C: {
          tabName: [
            "Camera measurement and positioning",
            "Delay calibration",
            "Color calibration",
            "Multi-camera switching",
            "Engine level/sequence management",
            "Virtual and real lighting coordination control",
          ],
          imgList: [
            "https://download.hecoos.com/enlightv/2025-17/37f549101ac217def309cf249ff30e36.png",
            "https://download.hecoos.com/enlightv/2025-17/bfadae3a04c9937fddfdbedf990bc4c8.png",
            "https://download.hecoos.com/enlightv/2025-17/7e6c8a04ff7f81a12ff5bca98b38bbb2.png",
            "https://download.hecoos.com/enlightv/2025-17/ccac8c851186e55acae1dc6ac1d105f7.png",
            "https://download.hecoos.com/enlightv/2025-17/23207610ab5776b51566e965a4053b44.png",
            "https://download.hecoos.com/enlightv/2025-17/2f2ac00a4b671a5b47513b91bff11a2b.png",
          ],
          msgList: [
            "The 5-minute automatic calculation process is completed to obtain the lens data file of the measurement result. The virtual camera in the three-dimensional world is perfectly aligned with the real camera in the scene without any deviation.",
            "Measuring the camera delay, media delay, and manually adjusting the tracking delay can ensure that the screen image and the extended image are completely synchronized, without any visual flaws such as stuttering and tearing.",
            "By comparing the colors captured by the camera with those of the original input, and automatically calculating the color calibration file, the accurate and unified colors of the screen image and the extended image can be achieved.",
            "When the number of tracking systems matches one-to-one with the cameras, the director can seamlessly and timely switch the shooting scenes among various tracking positions as needed, thereby expressing rich and diverse visual language.",
            "Match the multiple virtual scene programs added on the timeline of the Server-C server with each scene level in Unreal Engine one by one, so as to realize the real-time control and triggering of sequence animations in the virtual scenes at any time.",
            "By using the lighting configuration schemes of virtual scenes to construct the lighting layout of real studios, HECOOS realizes the direct control of real lamps through the ART-NET protocol, achieving synchronous lighting linkage in virtual reality.",
          ],
        },
        server_R: {
          tabName: [
            "Rivermax Cluster Rendering",
            "Engine selection",
            "Reverse control of the engine",
          ],
          imgList: [
            "https://download.hecoos.com/enlightv/2025-37/db71ad0270366115e54aebeb70ad6013.png",
            "https://download.hecoos.com/enlightv/2025-17/1e162cde5a14bffd1123ac5213c9fc89.png",
            "https://download.hecoos.com/enlightv/2025-35/157a875b18394fa009714279ac70cd93.png",
          ],
          msgList: [
            "The internal perspective rendering frame is shared among other rendering nodes in the cluster, avoiding waste of rendering resources of each node. With the reasonable division of labor among multiple nodes, the quality and smoothness of the frame are improved. The SMPTE 2110 synchronization strategy is used to lock the frame for each rendering node, ensuring that the output of Unreal Engine is synchronized with the camera.",
            "As a powerful engine carrier, hecoos integrates the visual content produced by real-time rendering engines such as Unreal Engine, Notch, Unity 3D, TouchDesigner and Processing into the playback and virtual shooting processes. Creators are not restricted to specific engines and can freely choose content tools to complete their works.",
            "During the virtual shooting process, through the settings of the real-time rendering engine of the HeCoos reverse editing system, the details of assets can be flexibly adjusted on the shooting site, making the shooting process smoother.",
          ],
        },
      },
      Info: "",
      canvasId: {
        type: String,
        required: true,
      },
      reviews: [
        {
          content:
            "Before hecoos, our ideas were always lost in translation from concepts to the screen. Now? Their previs workflow lets us see exactly what we're building before we build it. We tweak. We refine. And with all those projection mapping tricks up its sleeve, what ends up on stage actually matches what's in our heads. No more butchering our vision because 'the tech can't handle it'. That's a game-changer for artists.",
          author: "Deng Bo",
          position: " Feiyang Carrot CEO&Producer",
          institution: "",
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.updateUnderlinePosition();
      this.setupSpanResizeObservers();
      window.addEventListener("resize", this.updateUnderlinePosition);
    });
    let section = this.$route.query.section;
    if (section) {
      this.scrollToSection();
      this.currentTabIndex = Number(section);
      this.selectTab(this.currentTabIndex);
    }
    initThreeNoiseEffect("canvasId");
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateUnderlinePosition);
  },
  methods: {
    scrollToSection() {
      const element = document.getElementById("product_section");
      if (element) {
        element.scrollIntoView({
          behavior: "smooth", // 平滑滚动
          block: "start", // 滚动到元素顶部
        });
      }
    },
    // 新增方法，用于处理 tab 切换
    selectTab(index) {
      this.currentTabIndex = index;

      // 重置所有内容的显示状态为 false
      this.showContents = this.showContents.map(() => false);
      // 将当前选中的内容显示状态设为 true
      this.showContents[index] = true;
      this.updateUnderlinePosition();
      if (index === 1) {
        this.Info = this.tabInfo.server_C;
      } else if (index === 2) {
        this.Info = this.tabInfo.server_R;
      } else {
        this.Info = this.tabInfo.server_D;
      }
      // 将index存储到本地
      // localStorage.setItem("tabIndex", index);
    },
    updateUnderlinePosition() {
      const switchList = this.$refs.switch_list;
      if (switchList) {
        const span = switchList.querySelectorAll("span")[this.currentTabIndex];
        const switchListRect = switchList.getBoundingClientRect();
        const spanRect = span.getBoundingClientRect();

        // 获取 span 的左右 padding 值
        const computedStyle = window.getComputedStyle(span);
        const paddingLeft = parseFloat(computedStyle.paddingLeft);
        const paddingRight = parseFloat(computedStyle.paddingRight);

        // 计算去除 padding 后的宽度
        this.underlineWidth = spanRect.width - paddingLeft - paddingRight;
        // 计算去除 padding 后的左侧偏移量
        this.underlineLeft = spanRect.left - switchListRect.left + paddingLeft;
      }
    },
    // 文字宽度变化监听
    setupSpanResizeObservers() {
      const spans = this.$refs.switch_list.querySelectorAll("span");
      const resizeCallback = () => {
        this.updateUnderlinePosition();
      };
      spans.forEach((span) => {
        const observer = new ResizeObserver(resizeCallback);
        observer.observe(span);
      });
    },
  },
  beforeMount() {
    this.Info = this.tabInfo.server_D;
    const n = this.$route.query.section;
    if (n) {
      // 重置所有内容的显示状态为 false
      this.showContents = this.showContents.map(() => false);
      // 将当前选中的内容显示状态设为 true
      this.showContents[n] = true;
    } else {
      this.showContents[0] = true;
    }
  },
  watch: {
    // "$route.query.section": function (newValue) {
    //   // console.log(newValue, 'newValue');
    //   this.showContents = this.showContents.map(() => false);
    //   // 将当前选中的内容显示状态设为 true
    //   this.showContents[newValue] = true;

    //   this.currentTabIndex = Number(newValue); // 更新当前索引
    //   this.updateUnderlinePosition(); // 调用下划线计算方法
    // },
    "$route.query": {
      handler(newValue, oldValue) {
        let section = newValue.section;
        // 处理参数变化的逻辑
        // 可以在这里根据新的参数重新加载数据等
        this.showContents = this.showContents.map(() => false);
        // 将当前选中的内容显示状态设为 true
        this.showContents[section] = true;

        this.currentTabIndex = Number(section); // 更新当前索引
        this.updateUnderlinePosition(); // 调用下划线计算方法
        this.selectTab(this.currentTabIndex);
        // window.location.reload();
      },
      // 深度监听，确保对象内部属性变化也能被捕获
      deep: true,
    },
  },
  components: {
    myHeader,
    myFooter,
    myText,
    myInquire,
    clickSwitch,
    BackToTop,
    Test,
    test,
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/en_pc/xty.scss";
@import "@/styles/optimize_adaptation.scss";
.underline {
  position: absolute;
  bottom: 0;
  height: 3px;
  background-color: #2a82e4;
  transition: all 0.3s ease;
}

.product {
  overflow: hidden;
}

.callMe {
  display: inline-block;
  text-decoration: none;
  padding: 16px 24px;
  line-height: 32px;
  border-radius: 40px;
  background-color: #147cf5;
  margin: 0 auto;
  margin-top: 100px;
  font-size: 22px;
  cursor: pointer;
  color: #fff;
  transition: all 0.3s ease;
}

.callMe:hover {
  transform: scale(1.05);
  background-color: #fff;
  color: #147cf5;
}
</style>
